import React, { useMemo } from "react";

const LandingContent = () => {
  // Mock data for available spots (adjust with real data if needed)
  const monthSpots = useMemo(() => ({ total: 6, booked: 4 }), []);
  const spotsLeft = monthSpots.total - monthSpots.booked;

  return (
    <section className="bg-white pt-6 pb-12 px-6 text-center">
      <div className="max-w-5xl mx-auto">
        {/* Divider under hero */}
        <div className="h-1.5 w-40 bg-[#fbb40b] rounded-full mx-auto mb-6" aria-hidden="true" />

        {/* Subheadline */}
        <p className="text-[#003366]/90 text-lg md:text-xl max-w-3xl mx-auto mb-6">
          Get access to off-market properties before they’re listed anywhere else. Propsourcing™ helps you find
          investment-grade opportunities.
        </p>

        {/* Key Achievement */}
        <div className="text-[#003366]/90 text-lg mb-6 font-semibold">
          <p className="mb-4">
            We’ve received over <span className="text-[#da3e13]">700 off-market properties</span> in the last 6 months
            for investors just like you!
          </p>
        </div>

        {/* Platform Image */}
        <div className="mb-8">
          <img
            src="/propsourcing-platform-screenshot.png"
            alt="Propsourcing™ Platform Screenshot"
            className="w-full max-w-3xl mx-auto rounded-xl shadow-lg"
          />
        </div>

        {/* Early Access Section */}
        <div className="bg-[#f3f4f6] p-8 rounded-xl mb-8">
          <h2 className="text-2xl md:text-3xl font-semibold text-[#003366] mb-4">
            Get Early Access to Off-Market Deals and Reduce Competition
          </h2>
          <p className="text-sm md:text-lg text-[#003366]/90 max-w-3xl mx-auto mb-6">
            While many buyers' agents talk about off-market properties, <b>Propsourcing™</b> gives you access to a curated
            selection of off-market deals that help you reduce the competition. Even though not every off-market deal will
            be a fit, you still get access to a pool of valuable opportunities — with about 5–10% high-quality deals.
            That's the reality of off-market properties.
          </p>
          <p className="text-sm md:text-lg text-[#003366]/90 max-w-3xl mx-auto">
            Our platform connects you with verified listings, detailed property information, and tools to evaluate each
            deal. We focus on providing transparency and helping you navigate through off-market options aligned with your
            investment goals.
          </p>
        </div>

        {/* Benefits */}
        <div className="flex flex-wrap items-center justify-center gap-2 mb-8">
          <span className="inline-flex items-center gap-1 rounded-full border px-3 py-1 text-xs font-medium text-[#003366] border-[#003366]/20 bg-[#003366]/5">
            Verified Agent Network
          </span>
          <span className="inline-flex items-center gap-1 rounded-full border px-3 py-1 text-xs font-medium text-[#003366] border-[#003366]/20 bg-[#003366]/5">
            Weekly Property Drops
          </span>
          <span className="inline-flex items-center gap-1 rounded-full border px-3 py-1 text-xs font-medium text-[#003366] border-[#003366]/20 bg-[#003366]/5">
            Investor-First Due Diligence
          </span>
        </div>

        {/* CTA */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <a
            href="https://calendly.com/YOUR-CALENDLY-LINK"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center bg-[#da3e13] text-white px-6 py-3 rounded-xl text-lg font-semibold hover:bg-[#b3320f]"
          >
            Book Your Free Strategy Call
          </a>
          <span className="text-sm text-[#003366]/80">
            Only {spotsLeft} of {monthSpots.total} spots left this month!
          </span>
        </div>

        <p className="mt-3 text-xs text-gray-600">No obligation · 100% confidential</p>
      </div>
    </section>
  );
};

export default LandingContent;
